<div *ngIf="isLoading" class="wrap skeleton">
  <div class="content">
  </div>
</div>

<div *ngIf="!isLoading && kCartData?.length" class="wrap" [ngClass]="{'v2': !vars.pageName?.match('stories|mini_story') || (vars.pageName?.match('stories|mini_story') && !isMobile)}">
  <div class="content">
    <div class="head">
      <div class="title">Add Products to Contribute</div>
    </div>
    <div class="products scroll-to-products">
      <div class="items">
        <div *ngFor="let item of kCartData" class="li kettokartv2 {{item?.type === 'kit' ? 'kit' : 'product'}}">
          <div *ngIf="item?.type === 'kit'" class="images imagesv2"><div *ngFor="let prodItem of item?.product; let i = index" class="image"><img *ngIf="i <=3 " loading="lazy" [attr.data-src]="prodItem?.image" [alt]="prodItem?.name" [default]="util.defaultImg" /></div></div>
          <div *ngIf="item?.type !== 'kit'" class="image"><img loading="lazy" [attr.data-src]="item?.product?.image" [alt]="item?.name" [default]="util.defaultImg" /></div>
          <!-- <div class="details" *ngIf="!vwo?.kettokart_design_change_AB()">
            <div class="top"><div class="title">{{item?.name}} <em *ngIf="item?.type === 'kit'" class="material-icons" (click)="viewKitInfo(item)" mat-ripple>info_outline</em></div><div class="unit"><span [innerHTML]="currency_symbol"></span>{{item?.perUnit}}/{{item?.unit || 'unit'}}</div></div>
            <div class="bottom" [ngStyle]="{'justify-content': (vars.pageName?.match('stories') && vwo.remove_supporters_and_raisedAB()) ? 'end' : 'normal'}">
              <div class="left" *ngIf="!(vwo.remove_supporters_and_raisedAB() && vars.pageName?.match('stories'))">
                <div *ngIf="item?.type === 'kit'" class="desc">{{item?.raised}} of {{item?.required}} {{item?.unit}} obtained</div>
                <div *ngIf="item?.type !== 'kit'" class="desc">{{item?.raised}} of {{item?.required}} {{item?.unit}} raised</div>
                <div class="progress">
                  <div class="progress-bar">
                    <div class="bar" [style.width]="item?.percentage + '%'"></div>
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="btn">
                  <app-basic-button *ngIf="!selectedIds.includes(item?.id)" preIcon="add" label="ADD" [themeConfig]="{height: '32px', fontSize: '12px', letterSpacing: '-0.24px', borderColor: 'linear-gradient(to top, rgba(0, 112, 111, 0.2), rgba(2, 231, 229, 0.2))', bgColor: 'rgba(255, 255, 255, 1)', textColor: '#019997'}" (btnClicked)="add(item)" />
                  <app-increment-btn *ngIf="selectedIds.includes(item?.id)" [labelCount]="item?.selectedQuantity" [themeConfig]="{height: '32px', fontSize: '12px', letterSpacing: '-0.24px', iconSize: '16px', textColor: '#019997', border: '1px solid #019997', bgColor: 'rgba(153, 229, 229, 0.30)'}" (onChange)="incrementAction($event, item)" />
                </div>
              </div>
            </div>
          </div> -->
          <div class="details detailsv2">
            <div class="top">
              <div class="title"><span>{{item?.name}}</span><em *ngIf="(item?.type === 'kit' && !item?.description) || item?.type !== 'kit'" class="material-icons" (click)="viewKitInfo(item)" mat-ripple>info_outline</em>
                <div class="descContainer" *ngIf="item?.description">
                  <div class="desc" [title]="item?.description">{{item?.description}}</div>
                  <em *ngIf="item?.type === 'kit'" class="material-icons" (click)="viewKitInfo(item)" mat-ripple>info_outline</em>
                </div>
              </div>
              <div class="bottomv2">
                <div class="unit"><span [innerHTML]="currency_symbol"></span>{{item?.perUnit}}/{{item?.unit || 'unit'}}</div>
                <div class="btn">
                  <app-basic-button *ngIf="!selectedIds.includes(item?.id)" preIcon="add" label="ADD" [themeConfig]="{height: '32px', fontSize: '12px', letterSpacing: '-0.24px', borderColor: 'linear-gradient(to top, rgba(0, 112, 111, 0.2), rgba(2, 231, 229, 0.2))', bgColor: 'rgba(255, 255, 255, 1)', textColor: '#019997'}" (btnClicked)="add(item)" />
                  <app-increment-btn *ngIf="selectedIds.includes(item?.id)" [labelCount]="item?.selectedQuantity" [themeConfig]="{height: '32px', fontSize: '12px', letterSpacing: '-0.24px', iconSize: '16px', textColor: '#019997', border: '1px solid #019997', bgColor: 'rgba(153, 229, 229, 0.30)'}" (onChange)="incrementAction($event, item)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isMobile" class="donate-btn"><app-basic-button postIcon="arrow_forward" [label]="(vars.pageName?.match('stories') && this.selectedItems?.length && vwo.kcart_stories_ctachange_AB()) ? 'Add to cart' : 'Contribute Now'" [themeConfig]="{height: '60px', fontSize: '17px', fontFamily: 'Proxima-Nova', letterSpacing: '-0.34px'}" (btnClicked)="openPayment()" /></div>

    </div>

    <!-- <div *ngIf="vars.pageName === 'stories'" class="or-section">
      <div class="or"><div class="hr-line"></div>OR<div class="hr-line"></div></div>
      <div class="action-section">
        <div class="left">
          <div class="title">Enter your preferred amount</div>
          <div class="sub-title">You can help them by contributing money</div>
        </div>
        <div class="right">
          <div class="btn">
            <app-basic-button label="Select Amount" [themeConfig]="{height: '32px', fontSize: '12px', fontFamily: 'var(--poppins-font-family)'}" (btnClicked)="otherAmount()" />
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>

<div *ngIf="!isLoading && !vars.pageName?.match('stories|mini_story') && !isMobile" class="or-wrap">
  <div class="or-section">
    <div class="or"><div class="hr-line"></div>OR<div class="hr-line"></div></div>
    <div class="action-section">
      <div class="left">
        <div class="title">Enter your preferred amount</div>
        <div class="sub-title">You can help them by contributing money</div>
      </div>
      <div class="right">
        <div class="btn">
          <app-basic-button label="Select Amount" [themeConfig]="{height: '32px', fontSize: '12px', fontFamily: 'var(--poppins-font-family)', borderColor: 'linear-gradient(to top, rgba(0, 112, 111, 0.2), rgba(2, 231, 229, 0.2))', bgColor: 'rgba(255, 255, 255, 1)', textColor: 'rgb(1, 153, 151)'}" postIcon="arrow_forward" (btnClicked)="otherAmount()" />
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template *ngIf="isMobile" [ngTemplateOutlet]="productDock" />

<app-donate-now *ngIf="openPaymentForm" [hidden]="true" [openOnload]="true" [showLabel]="true" [label]="('Stories.donations.makeDonation' | translatePipe |async)" [fundraiser]="vars.fundraiser" [position]="9" [openDonate]="isMobile" [recommendTag]="false" [tagLabel]="''" [theme]="''"></app-donate-now>

<ng-template #productDock>
  <div class="product-dock-btn">
    <div *ngIf="!showCostBreak" class="note">🤌 Most people contribute grocery kit for wholistic impact</div>
    <div class="sections">
      <div *ngIf="vars.selectedKCart" class="section-1">
        <div *ngIf="vars.kCartDockData?.image" class="image"><img loading="lazy" [src]="vars.kCartDockData?.image" alt="grocery-kit" [default]="util.defaultImg" /></div>
        <div class="desc">
          <div class="title" (click)="openCostBreak()">{{vars.kCartDockData?.title}} <em *ngIf="totalAmount" class="material-icons" mat-ripple>{{showCostBreak ? 'expand_more' : 'chevron_right'}}</em></div>
          <div class="amount"><span [innerHTML]="currency_symbol"></span>{{totalAmount}}</div>
        </div>
      </div>
      <div class="section-2"><app-basic-button postIcon="arrow_forward" [label]="(vars.pageName?.match('stories') && this.selectedItems?.length && vwo.kcart_stories_ctachange_AB()) ? 'Add to cart' : 'Contribute Now'" [themeConfig]="{fontSize: '12px', fontFamily: 'Poppins, sans-serif'}" (btnClicked)="openPayment()" /></div>
    </div>
  </div>
</ng-template>



<ng-template #kitInfo>
  <div class="kit-info-wrap">
    <div class="close-wrap desk-only" (click)="closeDialog()" mat-ripple><em class="material-icons">close</em></div>
    <div class="head-dash" (click)="closeDialog()" mat-ripple></div>
    <div class="hr-line"></div>
    <div class="section-1">
      <div *ngIf="selectedKit?.type === 'kit'" class="title">This {{selectedKit?.name}} Contains: </div>
      <div *ngIf="selectedKit?.type === 'kit'" class="products">
        <div *ngFor="let item of selectedKit?.product" class="li">
          <div class="name">{{currency !== 'INR' ? "5 x " : ""}}{{item?.name}} {{item?.quantity}}{{item?.unit}} </div>
          <div *ngIf="item?.amount" class="amount"><span [innerHTML]="currency_symbol"></span>{{item?.amount}}</div>
        </div>
        <div class="li">
          <div class="name"><strong>Total</strong></div>
          <div class="amount"><strong><span [innerHTML]="currency_symbol"></span>{{selectedKit?.perUnit}}</strong></div>
        </div>
      </div>
      <div *ngIf="selectedKit?.type !== 'kit'" class="products">
        <div class="li" style="border: none;">
          <div class="name">{{currency !== 'INR' ? "5 x " : ""}}{{selectedKit?.name}}</div>
          <div *ngIf="selectedKit?.perUnit" class="amount"><span [innerHTML]="currency_symbol"></span>{{selectedKit?.perUnit}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!selectedIds.includes(selectedKit?.id)" class="section-2">
      <app-basic-button label="Add {{selectedKit?.name}}" postIcon="add" [themeConfig]="{height: '48px', fontSize: '14px', letterSpacing: '-0.28px'}" (btnClicked)="add(selectedKit);closeDialog();" />
    </div>
  </div>
</ng-template>

<ng-template #costBreak>
  <div class="cost-break-wrap">
    <div class="close-wrap desk-only" (click)="closeDialog()" mat-ripple><em class="material-icons">close</em></div>
    <div class="head-dash" (click)="closeDialog()" mat-ripple></div>
    <div class="hr-line"></div>
    <div class="section-1">
      <div class="title">Price Breakdown</div>
      <div class="products">
        <div *ngFor="let item of selectedItems" class="li">
          <div class="name">{{currency !== 'INR' ? "5 x " : ""}}{{item?.name}}</div>
          <div class="quantity">x{{item?.selectedQuantity}}</div>
          <div class="amount"><span [innerHTML]="currency_symbol"></span>{{item?.selectedQuantity * item?.perUnit}}</div>
        </div>
      </div>
    </div>
  </div>
  <ng-template [ngTemplateOutlet]="productDock" />
</ng-template>